<template lang="pug">
extends ./BaseMessage/BaseMessage.pug
block child
  .message-container(:class="baseClass")
    .message-item(v-if="senderType")
      avatar( :inWebchat="inWebchat",
              :senderType="senderType",
              :avatarPhoto="avatar",
              :senderInitials="senderInitials"
              :avatarAltText="avatarAltText")
      .message-bubble
        .message-bubble_header
          .message-bubble_name
            i(v-if="senderType === 'customers'",
              :title="channelInfo.title",
              :class="`aiq-ico-conversation-${channel}`")
            span {{ senderName }}
          .message-bubble_date
            aiq-timeago(:since="messageDate" :maxTime="maxTime")
        .message-bubble_content(v-html="content")
</template>

<script>
import BaseMessage from './BaseMessage/BaseMessage.vue';
import Avatar from '../../Avatar.vue';

export default {
  extends: BaseMessage,
  name: 'emailMessage',
  components: {
    Avatar,
  },
  props: {
    inWebchat: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.message-agent {
  .message-bubble {
    overflow: hidden;
  }
}
.asset-container {
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }
}
</style>
